
<div class="p-inputgroup" [formGroup]="form">
  <lib-worked-calendar
    formControlName="date"
    [inputId]="inputId"
    [name]="name"
    ngDefaultControl
    [siteId]="(currentContext | async)?.site.id"
    [disabled]="disabled"
    [readonly]="readonly"
    (onSelect)="onDateSelected($event)"
    (onFocus)="touched()">
  </lib-worked-calendar>

  <p-dropdown
    *ngIf="!(isTpm | async)"
    [options]="shiftItems | async"
    formControlName="shiftId"
    [readonly]="readonly"
    [name]="name + '_shift'"
    (onFocus)="touched()"
    (onChange)="onShiftSelected($event.value)"
    placeholder="Choose Shift"
    appendTo="body">
  </p-dropdown>

  <button
    *ngIf="showClearButton"
    pButton class="p-button-info"
    type="button"
    [disabled]="this.form.disabled"
    icon="pi pi-times"
    title="Clear Shift"
    (click)="clearSelection()">
  </button>
</div>
